<template>
	<div class="form-group">
		<div class="d-flex justify-content-between align-items-center mb-2">
			<label class="font-weight-bold mb-0">{{ label }}</label>
			<div>
				<a class="" :href="warehouseSettingLink" target="_blank">
					+ Add Warehouse
				</a>
			</div>

		</div>
		<multiselect
			placeholder="Select Warehouse"
			label="label"
			track-by="_id"
			v-model="selected"
			:options="warehouses"
			:show-labels="false"
			:allow-empty="false"
			:loading="isFetching"
			:disabled="warehouses.length === 0"
			@select="onChange">
			<template slot="option" slot-scope="props">
				<div class="option__desc d-flex flex-column">
					<span class="option__label">{{ props.option.label }}</span>
					<span class="option__address mt-1">
						{{ props.option.address }}
						<span class="ml-1" v-if="props.option.subdistrict && props.option.subdistrict !== null">{{ props.option.subdistrict.name }}</span>
						<span class="mx-1" v-if="props.option.city && props.option.city !== null">{{ props.option.city.name }}</span>,
						<span v-if="props.option.province && props.option.province !== null">{{ props.option.province.name }}</span>
					</span>
				</div>
			</template>
		</multiselect>
	</div>
</template>

<script>
import warehouseApi from '@/api/warehouse';
import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'WarehouseSelect',
	props: {
		label: {
			type: String,
			default: 'Warehouse',
		},
		warehouse: {
		},
	},
	data() {
		return {
			warehouses: [],
			selected: null,
			isFetching: false,
		};
	},
	computed: {
		warehouseSettingLink() {
			const baseUrl = window.location.origin;
			const link = `${baseUrl}/settings/store#warehouse`;
			return link;
		},
	},
	methods: {
		fetch() {
			this.isFetching = true;
			const params = {
				page: 1,
				limit: 100,
				is_deleted: false,
			};
			const callback = (response) => {
				const warehouses = response.data;
				this.warehouses = warehouses;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Warehouses',
					text: message,
				});
				this.isFetching = false;
			};
			warehouseApi.getWarehouses(params, callback, errorCallback);
		},
		onChange(value) {
			this.selected = value;
			this.$emit('input', this.selected);
		},
	},
	created() {
		this.fetch();
	},
};
</script>

<style lang="scss" scoped>
.option__label {
	// text-transform: capitalize;
	font-size: 16px;
	font-weight: 500;
}

.option__address {
	font-size: 12px;
	color: #797979;
}

.multiselect__option--selected {
	background: #f3f3f3;
	color: #35495e;
	font-weight: 700;

	.option__label {
		font-weight: 600 !important;
	}

	.option__address {
		font-weight: 500 !important;
	}
}
</style>
